"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const Score_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Score"));
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let MetricCard = class MetricCard extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.controllerColor = new ColorLibController_1.default();
    }
    polishRank(rank) {
        let myRank = Math.round(rank);
        if (myRank === 0 && rank > 0)
            myRank = 1;
        else if (myRank > 5)
            myRank = 5;
        return myRank;
    }
    get polishScore() {
        const score = new Score_1.default(this.metric.score, '');
        return score.value;
    }
    generateColoRank(rank) {
        return this.controllerColor.getRankColor(this.polishRank(rank).toString());
    }
    generateColoRankHLT(rank) {
        return this.controllerColor.getDiseasesColor(this.polishRank(rank).toString());
    }
    calculateMetricLevel(rank) {
        return this.controllerColor.getRankLabel(this.polishRank(rank));
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], MetricCard.prototype, "metric", void 0);
MetricCard = __decorate([
    (0, vue_property_decorator_1.Options)({})
], MetricCard);
exports.default = MetricCard;
